//资源中心--------------------------------------------

let resourceBaseUrl;
//云课中心--------------------------------------------
let cloudClassBaseUrl;
//登录--------------------------------------------
let loginBaseUrl;

//预览服务器--------------------------------------------
let previewUrl;

if (process.env.NODE_ENV === 'production') {
    /*第二层if，根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境*/
    //production 生产环境
    if (process.env.VUE_APP_FLAG === 'pro') {
        resourceBaseUrl = location.origin;
        cloudClassBaseUrl = location.origin;
        //预览服务器地址--------------------------------------------
        if (location.origin.indexOf('test-resource') !== -1) {
            //测试
            previewUrl = 'https://tyl.amdox.com.cn';
            //登录--------------------------------------------
            loginBaseUrl = 'https://test-security.amdox.com.cn/';
        } else if (location.origin.indexOf('resource') !== -1) {
            //生产
            previewUrl = 'https://yl.amdox.com.cn';
            loginBaseUrl = 'https://security.amdox.com.cn/';
        } else {
            //本地部署
            previewUrl = 'https://tyl.amdox.com.cn';
            loginBaseUrl = 'http://' + location.hostname + ":13990";
        }
    } else {
        //test 测试环境
        //资源--------------------------------------------
        resourceBaseUrl = location.origin;
        //云课--------------------------------------------
        cloudClassBaseUrl = location.origin;

        //预览服务器地址--------------------------------------------
        if (location.origin.indexOf('test-resource') !== -1) {
            //测试
            previewUrl = 'https://tyl.amdox.com.cn';
            //登录--------------------------------------------
            loginBaseUrl = 'https://test-security.amdox.com.cn/';
        } else {
            //生产
            previewUrl = 'https://yl.amdox.com.cn';
            loginBaseUrl = 'https://security.amdox.com.cn/';
        }
    }
    //test 测试环境
} else {
    //dev 开发环境
    resourceBaseUrl = '/api';
    cloudClassBaseUrl = '/cloudClassApi';
    loginBaseUrl = '/loginApi';
    previewUrl = 'https://tyl.amdox.com.cn';
    // previewUrl = 'http:192.168.5.21:8012'
}
export const RESOURCE_BASE_URL = resourceBaseUrl;
export const CLOUD_CLASS_BASE_URL = cloudClassBaseUrl;
export const LOGIN_BASE_UTL = loginBaseUrl;
export const PREVIEW_URL = previewUrl;
